var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"collapse",attrs:{"id":_vm.collapseId,"data-parent":_vm.parentCollapseId}},[_c('div',{staticClass:"row"}),_vm._v(" "),(_vm.showBottomSpacer)?_c('div',{staticClass:"pt-10"}):_vm._e()])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5184ea21","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/cinemas/CityCinemaFiltersMobile.vue
// module id = 2E73
// module chunks = 0